import {combineReducers} from 'redux';
import {reducer as form} from "redux-form";
import progress from "./progress";
import results from "./results";
import switcher from "./switcher";

// Root Reducer
export const rootReducer = combineReducers({
  form,
  progress,
  results,
  switcher
});


// WEBPACK FOOTER //
// ./src/reducers/index.js